<template>
  <div v-loading="loading">
    <el-table
      v-if="tableConfig"
      :key="tableKey"
      :data="stockTakingReports.data"
      style="width: 100%"
      row-key="id"
      highlight-current-row
      :row-class-name="'pointer-row'"
      @sort-change="handleSortChange"
      @row-click="(row) => $router.replace('/processes/stock-takings/stock-taking-reports/view/' + row.id)"
    >
      <component
        :is="column.value"
        v-for="column in tableConfig.columns"
        :key="column.value"
      />
      <el-table-column
        fixed="right"
        label=""
        width="230"
        style="text-align: right;"
      >
        <template
          slot="header"
        >
          <table-settings
            v-if="tableConfig"
            :config="tableConfig"
            :allcolumns="allColumns"
            :labels="labels"
            store-module="stockTakingReport"
            :options="['settings']"
          />
        </template>
        <template
          slot-scope="scope"
        >
          <Actions :stock-taking-report="scope.row" />
        </template>
      </el-table-column>
    </el-table>
    <div class="el-card-footer">
      <el-pagination
        background
        :current-page.sync="currentPage"
        :page-sizes="[20, 50, 100, 200]"
        :page-size="stockTakingReports.per_page"
        layout="total, prev, pager, next"
        :total="stockTakingReports.total"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
  import Actions from './Actions';
  import TableSettings from '../../../TableSettings';
  import columns, { allColumns, labels } from './columns';

  export default {
    components: {
      Actions,
      TableSettings,
      ...columns,
    },
    data() {
      return {
        labels,
        allColumns,
        tableKey: 0,
        currentPage: 1,
        currentSort: {
          prop: 'created_at',
          order: 'desc',
        },
      };
    },
    computed: {
      stockTakingReports() {
        return this.$store.getters['stockTakingReport/stockTakingReports'];
      },
      tableConfig() {
        return JSON.parse(JSON.stringify(this.$store.getters['stockTakingReport/tableConfig']));
      },
      loading() {
        return this.$store.getters['stockTakingReport/loading'];
      },
    },
    watch: {
      tableConfig() {
        this.tableKey++;
      },
    },
    async mounted() {
      this.$store.commit('stockTakingReport/setFilterString', '');
      this.$store.commit('stockTakingReport/setCurrentPage', this.currentPage);
      this.$store.commit('stockTakingReport/setSorting', this.currentSort);
      await this.$store.dispatch('stockTakingReport/fetchAll');
    },
    methods: {
      handleCurrentChange(val) {
        this.$store.commit('stockTakingReport/setCurrentPage', val);
        this.$store.dispatch('stockTakingReport/fetchAll');
      },
      handleSortChange({ column, prop, order }) {
        if (column.sortable === 'custom') {
          this.$store.commit('stockTakingReport/setSorting', { prop, order });
          this.$store.dispatch('stockTakingReport/fetchAll');
        }
      },
    },
  };
</script>


